export default {"src":"/_next/static/media/flagIcon.c7913ec8.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};